const GET_WEATHER = 'GET_WEATHER';

export function getWeather(latitude, longitude) {
  const params = new URLSearchParams();
  if (latitude != null && String(latitude).trim() !== '') {
    params.set('latitude', String(latitude));
  }
  if (longitude != null && String(longitude).trim() !== '') {
    params.set('longitude', String(longitude));
  }
  const query = params.toString();

  return {
    type: GET_WEATHER,
    request: {
      op: 'get',
      path: `/@weather${query ? `?${query}` : ''}`,
    },
  };
}
